import React, { useState } from 'react';
import StatementPanel from './StatementPanel';
import ExpensesPanel from './ExpensesPanel';
import AssetsPanel from './AssetsPanel';
import AccountsPanel from './AccountsPanel';

// ── Finance hub ───────────────────────────────────────────────────────────
// Acts as a wrapper around four sub-tabs the boss wants grouped together:
//   - Statement (existing bank-statement reconciliation + dashboard)
//   - Accounts  (accountant pack, EOFY readiness, P&L) — placeholder for now
//   - Assets    (asset register + depreciation) — placeholder for now
//   - Expenses  (general expense tracking) — placeholder for now
//
// Sub-tab navigation is local state (no react-router) to match the rest of
// the app's tab pattern (see App.js / AdminShell.jsx).

const SUB_TABS = [
  { key: 'statement', label: 'Statement' },
  { key: 'accounts',  label: 'Accounts'  },
  { key: 'assets',    label: 'Assets'    },
  { key: 'expenses',  label: 'Expenses'  },
];

const NAVY    = '#1E3A4A';
const ACCENT  = '#F5C518'; // yellow underline matches the rest of the app
const BORDER  = '#E5E7EB';
const MUTED   = '#64748B';

export default function FinancePage() {
  const [active, setActive] = useState('statement');

  return (
    <div>
      {/* Sub-tab bar */}
      <div style={{
        display: 'flex',
        gap: 4,
        borderBottom: `1px solid ${BORDER}`,
        marginBottom: 16,
        flexWrap: 'wrap',
      }}>
        {SUB_TABS.map(t => {
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setActive(t.key)}
              style={{
                padding: '10px 20px',
                background: 'transparent',
                border: 'none',
                borderBottom: `3px solid ${isActive ? ACCENT : 'transparent'}`,
                color: isActive ? NAVY : MUTED,
                fontWeight: isActive ? 800 : 600,
                fontSize: 14,
                cursor: 'pointer',
                marginBottom: -1,
                letterSpacing: 0.3,
                transition: 'border-color 0.15s, color 0.15s',
              }}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {/* Active sub-tab content */}
      {active === 'statement' && <StatementPanel />}
      {active === 'accounts'  && <AccountsPanel />}
      {active === 'assets'    && <AssetsPanel />}
      {active === 'expenses'  && <ExpensesPanel />}
    </div>
  );
}

function ComingSoon({ title, subtitle }) {
  return (
    <div style={{
      background: '#FAFAF7',
      border: `1px solid ${BORDER}`,
      borderRadius: 16,
      padding: '60px 24px',
      textAlign: 'center',
    }}>
      <div style={{ fontSize: 32, marginBottom: 8 }}>🚧</div>
      <div style={{ fontSize: 18, fontWeight: 800, color: NAVY, marginBottom: 6 }}>
        {title} — coming soon
      </div>
      <div style={{ fontSize: 13, color: MUTED, maxWidth: 480, margin: '0 auto', lineHeight: 1.5 }}>
        {subtitle}
      </div>
    </div>
  );
}
